/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CompetenceCategory} from "../model/competence-category";
import {DeleteCompetenceCategoryRequest} from "../model/delete-competence-category-request";
import {ListData} from "../model/list-data";
import {SearchParamRequest} from "../model/search-param-request";
import {SuccessResponse} from "../model/success-response";
import {UpdateCompetenceCategoryRequest} from "../model/update-competence-category-request";

@Injectable({
    providedIn: "root",
})
export class SimCompetenceCategoryService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteCompetenceCategory(request: DeleteCompetenceCategoryRequest) {
        return super.post<SuccessResponse>(`/api/CompetenceCategory/DeleteCompetenceCategory`, request);
    }

    public getCompetenceCategories() {
        return super.get<CompetenceCategory[]>(`/api/CompetenceCategory/GetCompetenceCategories`, );
    }

    public getCompetenceCategoriesByIds(categoryIds: string[]) {
        return super.post<CompetenceCategory[]>(`/api/CompetenceCategory/GetCompetenceCategoriesByIds`, categoryIds);
    }

    public getFilteredCompetenceCategories(searchParameters: SearchParamRequest) {
        return super.get<ListData<CompetenceCategory>>(`/api/CompetenceCategory/GetFilteredCompetenceCategories`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public upsertCompetenceCategory(request: UpdateCompetenceCategoryRequest) {
        return super.post<CompetenceCategory>(`/api/CompetenceCategory/UpsertCompetenceCategory`, request);
    }
}